module.exports = __webpack_public_path__ + "static/media/icon_77.9497c3ae.svg";